import { z } from 'zod';

export const OriginIdSchema = z.string().brand('OriginId');
export const DestinationIdSchema = z.string().brand('DestinationId');

export const DirectionKeySchema = z
	.object({
		originId: OriginIdSchema,
		destinationId: DestinationIdSchema,
	})
	.transform(({ originId, destinationId }) => `${originId}-${destinationId}`)
	.brand('DirectionKey');

export const DirectionSchema = z.object({
	originId: OriginIdSchema,
	destinationId: DestinationIdSchema,
	origin: z.object({
		lat: z.number(),
		lng: z.number(),
	}),
	destination: z.object({
		lat: z.number(),
		lng: z.number(),
	}),
});

export const createDirectionKey = (
	originId: string,
	destinationId: string,
): DirectionKey => `${originId}-${destinationId}` as DirectionKey;

export interface Direction extends z.infer<typeof DirectionSchema> {}
export type OriginId = z.infer<typeof OriginIdSchema>;
export type DestinationId = z.infer<typeof DestinationIdSchema>;
export type DirectionKey = z.infer<typeof DirectionKeySchema>;
